import NavComponent from "../../lib/nav_component";
import { Nav, NavConfig } from "../../nav";

export const NavRootConfig = {
  componentTypeKey: "NavRoot",
  baseHtmlClass: "nav",
  selector: ".nav",
  datasetConfigKey: "nav_root__config",
};

export class NavRoot extends NavComponent {
  static get config() {
    return NavRootConfig;
  }

  constructor(id_or_element) {
    super(id_or_element, NavRoot.config);
    this.wellBooted = false;
    this.setDatasetConfig(NavRoot.config.datasetConfigKey);
    this.handleEvent(
      NavConfig.bootedEventName,
      this.handleBootedEvent.bind(this),
    );
    this.nav = this.getNav();
    this.renderInitial();
    this.render();
  }

  getNav() {
    const navConfig = { ...this.datasetConfig }; // Clone the config before modding.
    navConfig.window = window;
    navConfig.document = document;
    return new Nav(this, navConfig);
  }

  renderInitial() {
    this.element.style.opacity = "1"; // Show the nav. It has opacity 0 by default in HTML. This ensures that it is hidden even before any stylesheets are loaded.
  }

  render() {
    this.conditionallySetHtmlClassState(
      !this.readStateMachineValue("booting"),
      "booted",
    );
    this.conditionallySetHtmlClassState(this.wellBooted, "well_booted");
  }

  handleBootedEvent(event) {
    setTimeout(() => {
      this.wellBooted = true;
      this.render();
    }, 500);
  }
}
